import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { FONT_COLOR } = colors;

const noDataStyles = makeStyles(() => ({
	containerHeight: {
		height: 'calc(100vh - 96px)',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	button: {
		background: '#3C228A',
		borderRadius: 74,
		height: 40,
		color: '#FFFFFF',
		width: 151,
		textTransform: 'none',
		'&:hover': {
			backgroundColor: '#3C228A'
		}
	},
	wrapper: {
		background: '#FFFFFFFF'
	},
	textOne: {
		fontFamily: 'Bogle-Regular',
		fontSize: (P) => (P.isSmallScreen ? '20px' : '24px'),
		color: FONT_COLOR,
		textAlign: 'center',
		padding: '0 30px'
	},
	textBasic: {
		fontFamily: 'Bogle-Regular',
		fontSize: (P) => (P.isSmallScreen ? '20px' : '24px'),
		color: FONT_COLOR,
		textAlign: 'center',
		paddingTop: '30px',
		paddingBottom: '30px'
	},
	textTwo: {
		fontFamily: 'Bogle-Light',
		fontSize: (P) => (P.isSmallScreen ? '16px' : '20px')
	}
}));

export default noDataStyles;
